import React, { useContext, useState } from 'react'
import 'moment-timezone'
import { Box, CardHeader, IconButton, ListItemIcon, Menu, MenuItem, Tooltip, Typography } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Link, useNavigate } from 'react-router-dom'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import CampaignIcon from '@mui/icons-material/Campaign'
import { useSnackbar } from 'notistack'
import postService from '../../../../services/postService'
import { UserInfoContext } from '../../../contexts/UserInfoContext'
import { CommunityAvatar } from '../../../commonUIComponents/CustomAvatar'
import momentUtil from '../../../../util/momentUtil'
import ReportPostModal from '../../ReportPostModal/ReportPostModal'

const PostCardHeader = ({ authToken, post, fetchPosts }) => {
  const { userInfo } = useContext(UserInfoContext)
  const { enqueueSnackbar } = useSnackbar()
  const { id, communityId, userId, createdDate } = post
  const [openReportPostModal, setOpenReportPostModal] = useState(false)
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const openMenuHandler = event => setAnchorEl(event.currentTarget)
  const closeMenuHandler = () => setAnchorEl(null)

  const onClickPostHeaderHandler = event => {
    navigate(`/communities/${communityId}`)
  }

  const editPostHandler = () => {
    closeMenuHandler()
  }

  const deletePostHandler = () => {
    closeMenuHandler()
    postService.deletePost(id)
      .then(res => {
        navigate('/home')
        fetchPosts()
        enqueueSnackbar('Successfully deleted the post!.', { variant: 'success' })
      })
      .catch(err => {
        console.log(err)
        enqueueSnackbar(err.response?.data?.message, { variant: 'error' })
      })
  }

  const reportPostModalOpenHandler = () => {
    setOpenReportPostModal(true)
  }

  const reportPostModalCloseHandler = () => {
    setOpenReportPostModal(false)
  }

  const reportPostHandler = () => {
    closeMenuHandler()
  }

  const subheader = post.nickname ? post.nickname : undefined
  const subheaderProps = post.nickname ? { fontSize: 12 } : undefined

  return (
    <>
      <CardHeader
        avatar={
          <IconButton component={Link} to={`/communities/${communityId}`} sx={{ p: 0 }}>
            <CommunityAvatar src={post.avatarImageUrl} communityId={post.communityId} />
          </IconButton>
        }
        titleTypographyProps={{ variant: 'body2' }}
        title={
          <Box onClick={onClickPostHeaderHandler}>
            r/{post.communityId}
            <Typography onClick={onClickPostHeaderHandler}
                        sx={{ display: 'inline', fontSize: 13 }}
                        component="span"
                        variant="body2"
                        color="text.secondary">
              {' - '}{momentUtil.createTimeDiffTag(createdDate)}
            </Typography>
          </Box>
        }
        subheaderTypographyProps={subheaderProps}
        subheader={
          subheader
        }
        action={
          <>
            <Tooltip title="Option">
              <IconButton
                onClick={openMenuHandler}
                sx={{ ml: 2 }}
                aria-controls={open ? 'post-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
              >
                <MoreVertIcon />
              </IconButton>
            </Tooltip>
              {authToken && userInfo?.id === userId
                ? (
                  <Menu
                    anchorEl={anchorEl}
                    id="post-menu"
                    open={open}
                    onClose={openMenuHandler}
                    onClick={closeMenuHandler}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 1
                        },
                        '&::before': {
                          content: '""',
                          display: 'block',
                          position: 'absolute',
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          bgcolor: 'background.paper',
                          transform: 'translateY(-50%) rotate(45deg)',
                          zIndex: 0
                        }
                      }
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  >
                    <MenuItem onClick={editPostHandler} to={`/update-post/${id}`} component={Link}>
                      <ListItemIcon>
                        <EditIcon fontSize="small" />
                      </ListItemIcon>
                      Edit
                    </MenuItem>
                    <MenuItem onClick={deletePostHandler}>
                      <ListItemIcon>
                        <DeleteIcon fontSize="small" />
                      </ListItemIcon>
                      Delete
                    </MenuItem>
                  </Menu>
                  )
                : (
                  <Menu
                    anchorEl={anchorEl}
                    id="post-menu"
                    open={open}
                    onClose={openMenuHandler}
                    onClick={closeMenuHandler}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 1
                        },
                        '&::before': {
                          content: '""',
                          display: 'block',
                          position: 'absolute',
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          bgcolor: 'background.paper',
                          transform: 'translateY(-50%) rotate(45deg)',
                          zIndex: 0
                        }
                      }
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  >
                    <MenuItem onClick={reportPostModalOpenHandler}>
                      <ListItemIcon>
                        <CampaignIcon fontSize="small" />
                      </ListItemIcon>
                      Report
                    </MenuItem>
                  </Menu>
                  )
              }
          </>
        }
      />
      <ReportPostModal post={post} comment={null} open={openReportPostModal} setOpenReportPostModal={setOpenReportPostModal} onClose={reportPostModalCloseHandler} submitOnSuccess={reportPostHandler} />
    </>
  )
}

export default PostCardHeader
